<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.zbrmc"  placeholder="中标人名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <my-select
                    placeholder="合同状态"
                    v-model="pgData.shbj"
                    :data="[
                        {key: '', value: '全部'}, 
                        {key: '0', value: '合同未签订'}, 
                        {key: '1', value: '合同已签订'}, 
                        {key: '2', value: '交易取消'}, 
                        {key: '3', value: '履约完成'}
                    ]"
                ></my-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="pgData.xmmc"  placeholder="项目名称/项目编号" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="pgData.bdmc"  placeholder="标段名称/标段编号" clearable></el-input>
            </el-form-item>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="项目信息" prop="zbprocode" min-width="220" fixed="left">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        {{scope.row.zbproname}}
                    </div>
                    <div class="table-info-row">
                        {{scope.row.zbprocode}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="标段信息" prop="bdcode" min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        {{scope.row.bdname}}
                    </div>
                    <div class="table-info-row">
                        {{scope.row.bdcode}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="中标人名称" prop="zbdwname" min-width="180"></el-table-column>
            <el-table-column label="合同状态" min-width="120">
                <template slot-scope="scope">
                    <state-list :row="scope.row" :config="STATE_CONF"></state-list>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                    <my-btn type="edit" @click="edit(scope.row)">变更状态</my-btn>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/tender/contract/list.json`">
        </my-pagination>

        <el-dialog
            title="变更状态"
            :visible.sync="dialogVisible"
            width="30%">
                <el-row>
                    <el-col :span="4" style="padding:5px;text-align:right">状态：</el-col>
                    <el-col :span="20">
                        <my-select
                            placeholder="请选择合同状态"
                            v-model="httype"
                            :data="[
                                {key: '0', value: '合同未签订'}, 
                                {key: '1', value: '合同已签订'}, 
                                {key: '2', value: '交易取消'}, 
                                {key: '3', value: '履约完成'}
                            ]"
                        ></my-select>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="status">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import STATE_CONF from './config/state'

export default {
    mixins: [LIST_PAGE_MIXIN,],
    data() {
        return{
            pgData: {
                sortname:'a.addtime',
                pagesize: 15,
                zhrmc:'',
                xmmc: '',
                bdmc:'',
                shbj:''
            },
            STATE_CONF,
            dialogVisible:false,
            httype:'',
            rowData:{},
        }
    },
    computed: {
        
    },
    watch: {
        'pgData.txtkeyVal':function(o,n){
            this.pgData.txtkey =escape(o)
        },
        dialogVisible:function(o,n){
            if(!o){
                this.httype = ''
            }
        }
    },
    methods: {
        edit(row){
            var that = this;
            that.dialogVisible = true;
            that.rowData = row;
        },
        status(){
            var that = this;
            if(!that.httype){
                ShowMsg('请选择要变更的状态', 'error');
                return
            }
            that.$post(`${this.getGetters('mngUrl')}/tender/contract/status.json`,{
                rowguid:that.rowData.rowguid,
                ggcode:that.rowData.ggcode,
                status:that.httype,
            }, data => {
                ShowMsg('变更成功', 'success');
                that.searchHandler();
                that.dialogVisible = false;
            })
        }
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
